import React, { memo } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { TimerIcon, ArrowRightIcon, TagIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export const EnhancedClearanceSection = memo(function EnhancedClearanceSection() {
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const products = [{
    id: 1,
    name: 'Gold Standard Whey - Vanilla',
    brand: 'Optimum Nutrition',
    price: 12.99,
    originalPrice: 59.99,
    discount: 78,
    rating: 4.8,
    reviewCount: 245,
    image: PRODUCT_IMAGES[0],
    stockLeft: 5
  }, {
    id: 2,
    name: 'Pre-Workout - Fruit Punch',
    brand: 'C4',
    price: 9.99,
    originalPrice: 39.99,
    discount: 75,
    rating: 4.6,
    reviewCount: 187,
    image: PRODUCT_IMAGES[1],
    stockLeft: 3
  }, {
    id: 3,
    name: 'Syntha-6 Protein Powder - Chocolate',
    brand: 'BSN',
    price: 14.99,
    originalPrice: 54.99,
    discount: 73,
    rating: 4.7,
    reviewCount: 156,
    image: PRODUCT_IMAGES[2],
    stockLeft: 7
  }, {
    id: 4,
    name: 'ISO100 - Strawberry',
    brand: 'Dymatize',
    price: 15.99,
    originalPrice: 64.99,
    discount: 75,
    rating: 4.9,
    reviewCount: 203,
    image: PRODUCT_IMAGES[3],
    stockLeft: 2
  }, {
    id: 5,
    name: 'Nitro-Tech - Cookies & Cream',
    brand: 'MuscleTech',
    price: 13.99,
    originalPrice: 59.99,
    discount: 77,
    rating: 4.5,
    reviewCount: 134,
    image: PRODUCT_IMAGES[4],
    stockLeft: 4
  }, {
    id: 6,
    name: 'Amino Energy - Blue Raspberry',
    brand: 'Optimum Nutrition',
    price: 8.99,
    originalPrice: 34.99,
    discount: 74,
    rating: 4.4,
    reviewCount: 98,
    image: PRODUCT_IMAGES[0],
    stockLeft: 6
  }];
  const totalSlides = Math.ceil(products.length / 2);
  return <div className="w-full" data-id="element-2226" data-mp="2hhxq16lt3da9">
        <div className="container mx-auto px-4" data-id="element-2227" data-mp="2mf68z9es3lck">
          <div className="bg-gradient-to-r from-red-600 to-orange-500 rounded-xl overflow-hidden mb-6" data-id="element-2228" data-mp="2meebtu5j9fk6">
            <div className="relative" data-id="element-2229" data-mp="2rc644pa3b3ow">
              <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: 'url(\'data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\')'
          }} data-id="element-2230" data-mp="2wddbwoc8g2vk"></div>
              <div className="flex flex-col md:flex-row items-center justify-between p-6" data-id="element-2231" data-mp="toc1od5u3312">
                <div className="mb-4 md:mb-0 text-center md:text-left" data-id="element-2232" data-mp="orlnxwhi4jit">
                  <span className="inline-block bg-yellow-400 text-red-800 text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-2233" data-mp="kqrygyoeuwnt">
                    LAST CHANCE
                  </span>
                  <h2 className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-2234" data-mp="1cgejhru7opcw">
                    CLEARANCE SALE
                  </h2>
                  <p className="text-white text-opacity-90 text-lg" data-id="element-2235" data-mp="18drstu9a1aha">
                    Up to 90% off! Once they're gone, they're gone!
                  </p>
                </div>
                <div className="flex flex-col items-center" data-id="element-2236" data-mp="3t6bo7npvhwy4">
                  <div className="flex items-center bg-white bg-opacity-20 p-3 rounded-lg mb-2" data-id="element-2237" data-mp="3o6qp9dapdole">
                    <TimerIcon className="w-5 h-5 text-white mr-2" data-id="element-2238" data-mp="1fy11erowfjot" />
                    <span className="text-white font-bold" data-id="element-2239" data-mp="1fvo85idoxmwg">Ending Soon:</span>
                  </div>
                  <div className="flex space-x-2" data-id="element-2240" data-mp="1kqkfdpri0gu5">
                    <div className="bg-white text-red-600 font-bold rounded-lg w-12 h-12 flex items-center justify-center text-xl relative" data-id="element-2241" data-mp="16xvueinmanb6">
                      02
                      <span className="text-xs absolute -bottom-4 text-white" data-id="element-2242" data-mp="1yo8xwqy3fbw1">
                        Days
                      </span>
                    </div>
                    <div className="bg-white text-red-600 font-bold rounded-lg w-12 h-12 flex items-center justify-center text-xl relative" data-id="element-2243" data-mp="23mtr46exgvaz">
                      18
                      <span className="text-xs absolute -bottom-4 text-white" data-id="element-2244" data-mp="1ulvtc5v31k0u">
                        Hrs
                      </span>
                    </div>
                    <div className="bg-white text-red-600 font-bold rounded-lg w-12 h-12 flex items-center justify-center text-xl relative" data-id="element-2245" data-mp="ears4lfwsn33">
                      45
                      <span className="text-xs absolute -bottom-4 text-white" data-id="element-2246" data-mp="aowsqm2wr073">
                        Min
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full mb-6" data-id="element-2247" data-mp="fpb2q9o2kk7r">
          <div className="container mx-auto px-4" data-id="element-2248" data-mp="fqdpc5ed00hv">
            {isMobile ? <div className="relative" data-id="element-2249" data-mp="3o65vuxf2eq8n">
                <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }} data-id="element-2250" data-mp="3j6b3sqjjzum0">
                  {products.map(product => <div key={product.id} className="snap-start flex-shrink-0 relative" style={{
              width: 'calc(50% - 6px)'
            }} data-id="element-2251" data-mp="30fa7695wob5m">
                      <EnhancedProductCard product={product} data-id="element-2252" data-mp="1e1ygezhegpl2" />
                      <div className="absolute top-2 right-2 z-20" data-id="element-2253" data-mp="1e4kwjnicwdew">
                        <div className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full flex items-center whitespace-nowrap" data-id="element-2254" data-mp="1i2s5vxahqcg2">
                          <TagIcon className="w-3 h-3 mr-1" data-id="element-2255" data-mp="lg5ib371tz4m" />
                          Only {product.stockLeft} left
                        </div>
                      </div>
                    </div>)}
                </div>
                <div className="flex justify-center gap-2 mt-4" data-id="element-2256" data-mp="zen58yp4r7lh">
                  {Array.from({
              length: totalSlides
            }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-2257" data-mp="2as7pvck4vfo4" data-mpi={index} />)}
                </div>
              </div> : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2258" data-mp="2747ysu1lcelq">
                {products.map(product => <div key={product.id} className="relative" data-id="element-2259" data-mp="2243gqzl1bbte">
                    <EnhancedProductCard product={product} data-id="element-2260" data-mp="1x620sniwnsm5" />
                    <div className="absolute top-2 right-2 z-20 flex flex-col sm:flex-row gap-1 sm:gap-2" data-id="element-2261" data-mp="1s7qnu3xbd1zp">
                      <div className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full flex items-center whitespace-nowrap" data-id="element-2262" data-mp="1o6wzj9fyll6a">
                        <TagIcon className="w-3 h-3 mr-1" data-id="element-2263" data-mp="3mlht6r8m0zpc" />
                        Only {product.stockLeft} left
                      </div>
                    </div>
                  </div>)}
              </div>}
          </div>
        </div>
        <div className="container mx-auto px-4" data-id="element-2264" data-mp="9px0d4d7rwyc">
          <div className="text-center" data-id="element-2265" data-mp="9rhsknc233t1">
            <a href="#" className="inline-flex items-center justify-center bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg transition-colors" data-id="element-2266" data-mp="3s3wehombjseg">
              View All Clearance Items
              <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-2267" data-mp="3i3nhw9of04yj" />
            </a>
          </div>
        </div>
      </div>;
});